<!-- @format -->

<span class="hmf-header-bold-xs hmf-text-transform-none">{{ attributeGroupName() }}: </span>
@if (selectedAttributeValueDisplayable()) {
	<span class="hmf-header-xs hmf-text-transform-none">{{ selectedAttributeValue() }}</span>
}
@if (errorMessage() && errorMessageDisplayable()) {
	<hmf-alert-banner
		messageType="error"
		[messageTitle]="errorMessage()"
		class="hmf-mt-xs hmf-display-block"></hmf-alert-banner>
}